import useAllowEditWorkflow from "hooks/useAllowEditWorkflow";
import { useDetermineShareFlowUserAccessType } from "hooks/useDetermineShareFlowUserAccessType";
import { ComponentPropsContextApi } from "layouts/Flow Designer/context";
import { ComponentPropsContext } from "layouts/Flow Designer/context";
import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { TextField } from "../StyledComponents";
import { styles } from "../..";
import { useDebouncer } from "hooks/useDebouncer";

export const PasswordInput = ({ action, getFieldValue }) => {
  const { actionForm, formErrors } = useContext(ComponentPropsContext);
  const { setActionForm, setFormErrors, filterValidationErrors } =
    useContext(ComponentPropsContextApi);
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";
  const { allowEditWorkflow } = useAllowEditWorkflow();
  const { isReadOnlyAccess } = useDetermineShareFlowUserAccessType(currentSavedFlow?.id);
  const [value, setValue] = useState(getFieldValue(action));
  const { debouncer: inputDebouncer } = useDebouncer(handleFormInputChange);

  const handleSetValue = (event) => {
    setValue(event.target?.value);
    inputDebouncer(event);
  };

  function handleFormInputChange(e) {
    const { name } = e.target;
    let actionFormCopy = { ...actionForm };

    setFormErrors((prev) => prev.filter((error) => error !== name));

    if (actionFormCopy[name]?.isPassword) {
      actionFormCopy[name] = {
        ...actionFormCopy[name],
        value,
        isPassword: true,
        isEncoded: false
      };
    }

    setActionForm({
      ...actionFormCopy,
      [name]: { ...actionFormCopy[name], value, isVariable: false }
    });
  }

  const handlePasswordInputBlur = (action) => {
    const fieldValue = getFieldValue(action);

    if (!fieldValue && action.isRequired) {
      setFormErrors((prev) => (prev.includes(action.field) ? prev : [...prev, action.field]));
    } else {
      filterValidationErrors(action.field);
    }
  };

  return (
    <TextField
      label={action.label}
      helperText={formErrors.includes(action.field) ? `${action.label} is required.` : ""}
      error={formErrors?.includes(action.field)}
      required={action.isRequired}
      width="100%"
      name={action.field}
      placeholder={action.placeholder || ""}
      sx={styles.w100}
      value={value}
      onChange={handleSetValue}
      onBlur={() => handlePasswordInputBlur(action)}
      type="password"
      variant="standard"
      InputLabelProps={{
        classes: {
          asterisk: styles.asterisk
        }
      }}
      disabled={isFlowActive || !allowEditWorkflow(isReadOnlyAccess)}
    />
  );
};
